import React from 'react';
import { Page, PageHeader, Card, TextField, Button, Text, useToast } from '@chatsdet/ui';
import { useSearch } from '@tanstack/react-router';
import { API_URL } from '../../config';
import { ApiError, toApiError } from '../../lib/api-error';
import { BRAND } from '../../brand';

export const CliLogin: React.FC = () => {
  const { toast } = useToast();
  const { name, cliCommand } = BRAND;
  const search = useSearch({ strict: false }) as { user_code?: string };
  const [userCode, setUserCode] = React.useState(search.user_code ?? '');
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async () => {
    if (!userCode.trim()) {
      toast.error('Enter your code', { reportError: false });
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch(`${API_URL}/cli-login/claim`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userCode: userCode.trim() }),
      });

      if (!response.ok) {
        throw await toApiError(response, 'Failed to approve login');
      }

      toast.success(`${name} access approved. You can return to the terminal.`);
    } catch (error) {
      const reportError = !(error instanceof ApiError && error.userError);
      toast.error(error instanceof Error ? error.message : 'Failed to approve login', {
        reportError,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Page>
      <PageHeader title={`${name} Login`} description={`Approve a ${name} login request.`} />
      <Card className="p-6 max-w-xl">
        <TextField
          label="User code"
          value={userCode}
          onChange={setUserCode}
          placeholder={`Enter the code from ${cliCommand} login`}
        />
        <div className="mt-4 flex items-center gap-3">
          <Button onPress={handleSubmit} isDisabled={isSubmitting}>
            Approve
          </Button>
          <Text size="sm" className="text-muted-foreground">
            You must be signed in to approve this request.
          </Text>
        </div>
      </Card>
    </Page>
  );
};
